import { MaterialKey, Materials, Swatch, SwatchBase } from '../../ts/types';
import chikara from './chikara';
// import chikara_spacekites from './chikara_spacekites';
import icarexPc31 from './icarex-pc-31';

export const clothWeightUnit = 'g/m²';

function enrichSwatches(
    material: MaterialKey,
    swatches: SwatchBase[]
): Swatch[] {
    return swatches.reduce((enriched, swatch) => {
        return [
            ...enriched,
            {
                ...swatch,
                material,
            },
        ];
    }, []);
}

const materials: Materials = {
    icarexPc31: {
        swatches: enrichSwatches('icarexPc31', icarexPc31),
        name: 'Icarex',
        meta: {
            weight: 31,
        },
    },
    chikara: {
        swatches: enrichSwatches('chikara', chikara),
        name: 'Chikara',
        meta: {
            weight: 41,
        },
    },

    // chikaraSpaceKites: {
    //     swatches: chikara_spacekites,
    //     name: 'Chikara | Space Kites',
    //     meta: {
    //         weight: 41,
    //     },
    // },
};

export const defaultMaterialKey: MaterialKey = 'icarexPc31';
export const defaultMaterial = materials[defaultMaterialKey];
export const defaultSwatch = defaultMaterial.swatches[0];

export const getSwatch = (key: MaterialKey, index) => materials[key].swatches.find(
    (swatch) => swatch.index === index
)

export default materials;
